import { MutationHookOptions, useMutation } from "@apollo/client";

import { RegisterUserMutation, RegisterUserMutationVariables } from "@ctypes";
import { REGISTER_USER } from "@graphql";

export const useSignUp = (
  options?: MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>,
) => {
  return useMutation<RegisterUserMutation, RegisterUserMutationVariables>(REGISTER_USER, options);
};
